import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useFirebaseAnalytics from "../utils/firebase/hooks/useFirebaseAnalytics";
import { FirebaseEventEnum } from "../utils/firebase/types";

export const useTrackUtmParams = () => {
  const { search } = useLocation();
  const { LogEvent } = useFirebaseAnalytics();
  const sentUtmSource = useRef(false);

  useEffect(() => {
    if (sentUtmSource.current) {
      return;
    }

    const params = new URLSearchParams(search);
    const utmCampaign = params.get("utm_campaign");
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");

    if (!utmSource && !utmMedium && !utmCampaign) {
      return;
    }

    LogEvent(FirebaseEventEnum.UTM_SOURCE, {
      ...(utmSource && { utm_source: utmSource }),
      ...(utmMedium && { utm_medium: utmMedium }),
      ...(utmCampaign && { utm_campaign: utmCampaign }),
    });

    sentUtmSource.current = true;
  }, [search, LogEvent]);
};
